// Categories for snack items
const categories = {
  DRINKS: 'Drinks',
  POPCORN: 'Popcorn',
  CHOCOLATE_CANDY: 'Chocolate & Candy',
  HOT_FOOD: 'Hot Food',
  OTHER: 'Other'
};

// Map item class codes to categories
const classCodesToCategories = {
  '0015': categories.DRINKS, // Water
  '0016': categories.DRINKS, // Soft drinks
  '0020': categories.DRINKS, // Soft drinks
  '0001': categories.POPCORN, // Popcorn
  '0003': categories.CHOCOLATE_CANDY, // Chocolates & candy
  '0031': categories.HOT_FOOD, // Hot food
  '0035': categories.HOT_FOOD, // Hot drinks
  '0065': categories.OTHER // Other snacks
};

// Function to get category for an item
const getCategoryForItem = (item) => {
  if (!item || !item.ItemClassCode) {
    return categories.OTHER;
  }
  
  return classCodesToCategories[item.ItemClassCode] || categories.OTHER;
};

// Function to group items by category
const groupItemsByCategory = (items) => {
  const grouped = {};
  
  // Initialize categories
  Object.values(categories).forEach(category => {
    grouped[category] = [];
  });
  
  // Group items
  items.forEach(item => {
    const category = getCategoryForItem(item);
    grouped[category].push(item);
  });
  
  return grouped;
};

export { categories, getCategoryForItem, groupItemsByCategory };
